// extracted by mini-css-extract-plugin
module.exports = {"RecoveryWrapper":"Recovery_RecoveryWrapper__3YlqL","grid":"Recovery_grid__lTY0K","imgWrap":"Recovery_imgWrap__1GhcS","divider":"Recovery_divider__1wXqm"};